import React, { useState } from 'react';
import { Table, Button, Modal, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Layout from '../../components/Layout';

const Setting = () => {
  const [settings, setSettings] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editIndex, setEditIndex] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm();

  const openAddModal = () => {
    reset();
    setEditIndex(null);
    setShowModal(true);
  };

  const openEditModal = (index) => {
    const setting = settings[index];
    reset(setting);
    setEditIndex(index);
    setShowModal(true);
  };

  const onSubmit = (data) => {
    if (editIndex !== null) {
      const updated = [...settings];
      updated[editIndex] = data;
      setSettings(updated);
      toast.success('Setting updated');
    } else {
      setSettings([...settings, data]);
      toast.success('Setting added');
    }
    setShowModal(false);
  };

  const deleteSetting = (index) => {
    const updated = settings.filter((_, i) => i !== index);
    setSettings(updated);
    toast.success('Setting deleted');
  };

  return (
    <Layout>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">System Settings</h3>
        <Button onClick={openAddModal} className='bg-dark'>+ Add Setting</Button>
      </div>
      <Table striped bordered hover responsive>
        <thead className="table-dark">
          <tr style={{ textAlign: 'center' }}>
            <th>Key</th>
            <th>Value</th>
            <th>Description</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {settings.length === 0 ? (
            <tr>
              <td colSpan="4" className="text-center">No settings found</td>
            </tr>
          ) : (
            settings.map((s, idx) => (
              <tr key={idx}>
                <td>{s.key}</td>
                <td>{s.value}</td>
                <td>{s.description}</td>
                <td style={{ textAlign: 'center' }}>
                  <Button
                    size="sm"
                    variant="warning"
                    className="me-2"
                    onClick={() => openEditModal(idx)}
                  >
                    Edit
                  </Button>
                  <Button size="sm" variant="danger" onClick={() => deleteSetting(idx)}>
                    Delete
                  </Button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>

      {/* Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{editIndex !== null ? 'Edit Setting' : 'Add Setting'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group className="mb-3">
              <Form.Label>Key</Form.Label>
              <Form.Control
                type="text"
                {...register('key', { required: true })}
                isInvalid={errors.key}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Value</Form.Label>
              <Form.Control
                type="text"
                {...register('value', { required: true })}
                isInvalid={errors.value}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Description</Form.Label>
              <Form.Control
                type="text"
                {...register('description')}
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              {editIndex !== null ? 'Update' : 'Add'}
            </Button>
            <Button variant="white" className='border-1 border-dark ms-2' onClick={() => setShowModal(false)}>
                          Cancel
                        </Button>
          </Form>
        </Modal.Body>
      </Modal>
      <ToastContainer />
    </Layout>
  );
};

export default Setting;